import React from 'react';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';
import cn from 'classnames';

const EditRubricCancelEditButtonIcon: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.5967 5.43774C17.877 5.43774 18.1073 5.52847 18.2881 5.70923C18.4686 5.88988 18.5595 6.11958 18.5596 6.39966C18.5596 6.67996 18.4688 6.91032 18.2881 7.09106L13.3789 12.0002L13.3877 12.009L18.2881 16.9084C18.4688 17.0892 18.5595 17.3196 18.5596 17.5999C18.5596 17.8802 18.4688 18.1105 18.2881 18.2913C18.1073 18.472 17.877 18.5627 17.5967 18.5627C17.3164 18.5627 17.086 18.472 16.9053 18.2913L12.0059 13.3909L11.9971 13.3821L7.08789 18.2913C6.90715 18.472 6.67679 18.5627 6.39648 18.5627C6.11641 18.5627 5.8867 18.4718 5.70605 18.2913C5.52529 18.1105 5.43457 17.8802 5.43457 17.5999C5.43461 17.3196 5.52534 17.0892 5.70605 16.9084L10.6143 12.0002L10.6055 11.9915L5.70605 7.09106C5.52529 6.9103 5.43457 6.68001 5.43457 6.39966C5.43465 6.11948 5.52538 5.8899 5.70605 5.70923C5.88673 5.52855 6.1163 5.43783 6.39648 5.43774C6.67684 5.43774 6.90713 5.52847 7.08789 5.70923L11.9883 10.6086L11.9971 10.6174L16.9053 5.70923C17.086 5.52851 17.3164 5.43779 17.5967 5.43774Z"
        fill={fillColor}
        stroke="#0E2467"
        strokeWidth="0.025"
      />
    </svg>
  );
};

export const EditRubricCancelEditButton: React.FC<{ onClick: () => void }> = ({
  onClick,
}) => {
  const language = useLanguage();
  return (
    <TouchTarget
      behavior={{
        type: 'onClick',
        onClick,
      }}
      label={language.rubricCancelEditLabel()}
      content={({ hovered, disabled }) => (
        <div
          className={cn(
            'w-12 h-12 rounded-full bg-white shadow-12px flex items-center justify-center text-gray-900',
            {
              'brightness-75': hovered,
              'brightness-50': disabled,
            },
          )}
        >
          <EditRubricCancelEditButtonIcon />
        </div>
      )}
    />
  );
};
